var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouseAndHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "House-Chimney-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "House Chimney 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.71 11.29 -3.14 -3.13A0.29 0.29 0 0 1 20.5 8V2a1 1 0 0 0 -1 -1h-3a1 1 0 0 0 -1 1v0.48a0.25 0.25 0 0 1 -0.15 0.23 0.26 0.26 0 0 1 -0.28 0L12.71 0.29a1 1 0 0 0 -1.42 0l-11 11a1 1 0 0 0 -0.21 1.09A1 1 0 0 0 1 13h1.25a0.25 0.25 0 0 1 0.25 0.25V23a1 1 0 0 0 1 1h5.75a0.25 0.25 0 0 0 0.25 -0.25V19a2.5 2.5 0 0 1 5 0v4.75a0.25 0.25 0 0 0 0.25 0.25h5.75a1 1 0 0 0 1 -1v-9.75a0.25 0.25 0 0 1 0.25 -0.25H23a1 1 0 0 0 0.92 -0.62 1 1 0 0 0 -0.21 -1.09Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouseAndHome);
export default ForwardRef;